import React, { useState } from 'react';
import ContactForm from './forms/contact';

interface ScheduleAdvisorSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const ScheduleAdvisorSidebar: React.FC<ScheduleAdvisorSidebarProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="offcanvas-backdrop fade show"
        onClick={onClose}
      ></div>
      <div
        className="offcanvas offcanvas-end show w-55"
        tabIndex={-1}
        id="scheduleAdvisorOffcanvas"
        aria-labelledby="scheduleAdvisorOffcanvas"
        style={{ zIndex: 1050 }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="scheduleAdvisorOffcanvas" style={{
            fontSize: '1.25rem',
            fontWeight: 'bold',
            marginLeft: '3rem',
            padding: '10px 0px'
          }}>
            Schedule Advisor Session
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>
        <div className="offcanvas-body scroller px-5">
          <div className="mb-4">
            {/* <p className="text-secondary" style={{ fontSize: '0.875rem' }}>
              Use the form below to send us a consultation request. We take all queries carefully, 
              and we try to respond to each request individually. If you provide your email address, 
              you agree that we may contact you to better understand the request you submitted.
            </p> */}
          </div>
          
          <ContactForm type="consultancy" onSuccess={onClose} />
        </div>
      </div>
    </>
  );
};

export default ScheduleAdvisorSidebar; 